import { render, staticRenderFns } from "./VDynamicGridColumn.vue?vue&type=template&id=3c0f11f9&"
import script from "./VDynamicGridColumn.vue?vue&type=script&lang=ts&"
export * from "./VDynamicGridColumn.vue?vue&type=script&lang=ts&"
import style0 from "./VDynamicGridColumn.vue?vue&type=style&index=0&id=3c0f11f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports